import { jsx as n, jsxs as d } from "react/jsx-runtime";
import { isValidElement as v, cloneElement as y, forwardRef as b, useId as N } from "react";
const A = {
  md: "text-body",
  sm: "text-caption"
}, C = {
  normal: "font-normal",
  bold: "font-bold"
}, L = {
  default: "text-text-default",
  muted: "text-text-muted",
  error: "text-text-error",
  accent: "text-text-accent",
  inverse: "text-text-inverse"
};
function W({
  size: t = "md",
  weight: r = "normal",
  tone: e = "default",
  as: o = "p",
  children: a
}) {
  const i = [A[t], C[r], L[e]].join(" ");
  return /* @__PURE__ */ n(o, { className: i, children: a });
}
const E = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4"
}, k = {
  1: "lg",
  2: "md",
  3: "sm",
  4: "sm"
}, w = {
  xl: "text-heading-xl",
  lg: "text-heading-lg",
  md: "text-heading-md",
  sm: "text-heading-sm"
}, _ = {
  left: "text-left",
  center: "text-center"
};
function I({ level: t, size: r, align: e = "left", children: o }) {
  const a = E[t], i = r ?? k[t], l = [w[i], "font-bold", _[e]].join(" ");
  return /* @__PURE__ */ n(a, { className: l, children: o });
}
const j = "inline-flex items-center justify-center px-6 font-sans font-bold", T = {
  primary: "bg-action-primary text-text-inverse",
  gradient: "bg-linear-to-r from-action-primary-from to-action-primary-to text-text-inverse shadow-glow",
  outline: "border border-action-primary bg-bg-default text-action-primary",
  neutral: "bg-action-disabled text-text-default",
  danger: "bg-action-danger text-text-inverse"
}, B = {
  md: "h-control-height",
  lg: "h-control-lg"
}, $ = {
  rounded: "rounded-md",
  pill: "rounded-full"
};
function z({
  variant: t = "primary",
  size: r = "md",
  shape: e = "rounded",
  disabled: o = !1,
  asChild: a = !1,
  className: i,
  children: l,
  type: s,
  ...c
}) {
  const u = [
    j,
    T[t],
    B[r],
    $[e],
    o ? "opacity-50 pointer-events-none" : "",
    i ?? ""
  ].filter(Boolean).join(" ");
  if (a) {
    if (!v(l))
      throw new Error("Button: asChild=true のとき children は単一の要素である必要があります");
    const m = l;
    return y(m, {
      ...c,
      className: [u, m.props.className ?? ""].filter(Boolean).join(" ")
    });
  }
  return /* @__PURE__ */ n("button", { type: s ?? "button", className: u, disabled: o, ...c, children: l });
}
const F = "text-text-accent underline";
function K({ href: t, external: r = !1, className: e, children: o, ...a }) {
  const i = [F, e ?? ""].filter(Boolean).join(" "), l = r ? {
    target: "_blank",
    rel: Array.from(/* @__PURE__ */ new Set([...(a.rel ?? "").split(" ").filter(Boolean), "noopener", "noreferrer"])).join(
      " "
    )
  } : {};
  return /* @__PURE__ */ n("a", { href: t, className: i, ...a, ...l, children: o });
}
const p = "w-full rounded-md border bg-bg-default pl-3 text-body text-text-default focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring disabled:opacity-50 disabled:pointer-events-none", h = "h-control-height";
function x(t) {
  return t ? "border-text-error" : "border-border-input";
}
function f(...t) {
  return t.filter(Boolean).join(" ");
}
const Y = b(function({ error: r = !1, suffix: e, className: o, ...a }, i) {
  const l = f(
    p,
    h,
    x(r),
    e ? "pr-10" : "pr-3",
    o
  );
  return /* @__PURE__ */ d("div", { className: "relative", children: [
    /* @__PURE__ */ n("input", { ref: i, className: l, ...a }),
    e ? /* @__PURE__ */ n("span", { className: "pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-body text-text-muted", children: e }) : null
  ] });
}), q = b(function({ error: r = !1, className: e, ...o }, a) {
  const i = f(p, "py-2 pr-3", x(r), e);
  return /* @__PURE__ */ n("textarea", { ref: a, className: i, ...o });
}), J = b(function({ options: r, placeholder: e, error: o = !1, className: a, ...i }, l) {
  const s = f(
    p,
    h,
    "appearance-none pr-8",
    x(o),
    a
  );
  return /* @__PURE__ */ d("div", { className: "relative", children: [
    /* @__PURE__ */ d("select", { ref: l, className: s, ...i, children: [
      e ? /* @__PURE__ */ n("option", { value: "", disabled: !0, children: e }) : null,
      r.map((c) => /* @__PURE__ */ n("option", { value: c.value, children: c.label }, c.value))
    ] }),
    /* @__PURE__ */ n(
      "svg",
      {
        "aria-hidden": "true",
        viewBox: "0 0 20 20",
        fill: "none",
        className: "pointer-events-none absolute top-1/2 right-3 h-4 w-4 -translate-y-1/2 text-text-muted",
        children: /* @__PURE__ */ n(
          "path",
          {
            d: "M5 7.5L10 12.5L15 7.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      }
    )
  ] });
}), Q = b(function({ error: r = !1, className: e, ...o }, a) {
  const i = f(p, h, "pr-3", x(r), e);
  return /* @__PURE__ */ n("input", { ref: a, type: "date", className: i, ...o });
}), V = b(function({ label: r, className: e, id: o, disabled: a, ...i }, l) {
  const s = N(), c = o ?? s;
  return /* @__PURE__ */ d(
    "label",
    {
      htmlFor: c,
      className: f(
        "inline-flex cursor-pointer items-center gap-2 text-body text-text-default",
        a ? "opacity-50 pointer-events-none" : "",
        e
      ),
      children: [
        /* @__PURE__ */ n("input", { ref: l, id: c, type: "checkbox", disabled: a, className: "peer sr-only", ...i }),
        /* @__PURE__ */ n(
          "span",
          {
            "aria-hidden": "true",
            className: f(
              "relative flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-text-muted",
              "after:text-[10px] after:font-bold after:leading-none after:text-text-inverse after:opacity-0 after:content-['✓']",
              "peer-checked:border-action-primary peer-checked:bg-action-primary peer-checked:after:opacity-100",
              "peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-focus-ring"
            )
          }
        ),
        /* @__PURE__ */ n("span", { children: r })
      ]
    }
  );
});
function X({ options: t, value: r, onChange: e, className: o, ...a }) {
  const i = (l, s) => {
    const c = s ? [...r, l] : r.filter((u) => u !== l);
    e(c);
  };
  return /* @__PURE__ */ n("div", { className: f("flex flex-col gap-3", o), ...a, children: t.map((l) => /* @__PURE__ */ n(
    V,
    {
      label: l.label,
      checked: r.includes(l.value),
      onChange: (s) => i(l.value, s.target.checked)
    },
    l.value
  )) });
}
const G = {
  plain: "flex flex-col gap-3",
  chip: "flex flex-wrap gap-2",
  card: "flex flex-col gap-3"
}, g = "h-4 w-4 accent-action-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring";
function ee({
  name: t,
  options: r,
  value: e,
  onChange: o,
  appearance: a = "plain",
  className: i,
  ...l
}) {
  return /* @__PURE__ */ n("div", { role: "radiogroup", className: f(G[a], i), ...l, children: r.map((s) => {
    const c = s.value === e, u = () => o(s.value);
    return a === "chip" ? /* @__PURE__ */ d("label", { className: "inline-flex cursor-pointer", children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: "radio",
          name: t,
          value: s.value,
          checked: c,
          onChange: u,
          className: "peer sr-only"
        }
      ),
      /* @__PURE__ */ n(
        "span",
        {
          className: f(
            "flex h-11 min-w-[72px] items-center justify-center rounded-md border px-3 text-center text-body",
            "peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-focus-ring",
            c ? "border-action-primary text-action-primary" : "border-border-input text-text-default"
          ),
          children: s.label
        }
      )
    ] }, s.value) : a === "card" ? /* @__PURE__ */ d(
      "label",
      {
        className: f(
          "flex w-full cursor-pointer items-center justify-between gap-4 rounded-md border p-4 text-body",
          c ? "border-action-primary bg-bg-info" : "border-border-default bg-bg-default"
        ),
        children: [
          /* @__PURE__ */ n("span", { children: s.label }),
          /* @__PURE__ */ n(
            "input",
            {
              type: "radio",
              name: t,
              value: s.value,
              checked: c,
              onChange: u,
              className: g
            }
          )
        ]
      },
      s.value
    ) : /* @__PURE__ */ d("label", { className: "flex cursor-pointer items-center gap-2 text-body text-text-default", children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: "radio",
          name: t,
          value: s.value,
          checked: c,
          onChange: u,
          className: g
        }
      ),
      /* @__PURE__ */ n("span", { children: s.label })
    ] }, s.value);
  }) });
}
function te({ label: t, required: r = !1, error: e, hint: o, children: a, className: i }) {
  const l = N(), s = `${l}-error`, c = `${l}-hint`;
  if (!v(a))
    throw new Error("FormField: children は単一の要素である必要があります");
  const u = a, m = u.props.id ?? l, S = [u.props["aria-describedby"], o ? c : void 0, e ? s : void 0].filter(Boolean).join(" ");
  return /* @__PURE__ */ d("div", { className: f("flex flex-col gap-2", i), children: [
    /* @__PURE__ */ d("label", { htmlFor: m, className: "text-caption font-bold text-text-default", children: [
      t,
      r ? /* @__PURE__ */ n("span", { className: "ml-1 text-text-error", children: "必須" }) : null
    ] }),
    y(u, {
      id: m,
      "aria-describedby": S || void 0,
      "aria-invalid": e ? !0 : void 0
    }),
    o ? /* @__PURE__ */ n("p", { id: c, className: "text-caption text-text-muted", children: o }) : null,
    e ? /* @__PURE__ */ n("p", { id: s, className: "rounded-md bg-bg-error-soft px-2 py-1 text-caption text-text-error", children: e }) : null
  ] });
}
const O = {
  info: "bg-bg-info",
  warning: "bg-bg-warning-soft text-text-warning",
  error: "bg-bg-error-soft text-text-error"
}, R = {
  inline: "",
  card: "rounded-md p-4"
};
function ne({ tone: t = "info", variant: r = "inline", children: e }) {
  const o = [O[t], R[r]].filter(Boolean).join(" ");
  return /* @__PURE__ */ n("div", { className: o, children: e });
}
const D = {
  accent: "bg-action-primary text-text-inverse",
  error: "text-text-error"
};
function re({ tone: t = "accent", children: r }) {
  const e = ["inline-flex items-center rounded-full px-2 py-0.5 text-caption font-bold", D[t]].join(
    " "
  );
  return /* @__PURE__ */ n("span", { className: e, children: r });
}
function ae({ onRemove: t, children: r }) {
  return /* @__PURE__ */ d("span", { className: "inline-flex items-center gap-1 rounded-full bg-border-default px-3 py-1 text-body text-text-default", children: [
    r,
    t && /* @__PURE__ */ n(
      "button",
      {
        type: "button",
        "aria-label": "削除",
        onClick: t,
        className: "ml-1 inline-flex items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring",
        children: "×"
      }
    )
  ] });
}
function le() {
  return /* @__PURE__ */ d("span", { className: "inline-flex items-center gap-1", role: "status", "aria-label": "読み込み中", children: [
    /* @__PURE__ */ n("span", { className: "h-2 w-2 animate-bounce rounded-full bg-action-primary" }),
    /* @__PURE__ */ n("span", { className: "h-2 w-2 animate-bounce rounded-full bg-action-primary [animation-delay:150ms]" }),
    /* @__PURE__ */ n("span", { className: "h-2 w-2 animate-bounce rounded-full bg-action-primary [animation-delay:300ms]" })
  ] });
}
function oe({ current: t, total: r }) {
  const e = Math.max(r, 0), o = Math.min(Math.max(t, 0), e), a = e > 0 ? o / e * 100 : 0;
  return /* @__PURE__ */ d("div", { className: "flex items-center gap-3", children: [
    /* @__PURE__ */ n(
      "div",
      {
        role: "progressbar",
        "aria-valuenow": o,
        "aria-valuemin": 0,
        "aria-valuemax": e,
        className: "h-3.5 flex-1 rounded-full bg-track",
        children: /* @__PURE__ */ n("div", { className: "h-full rounded-full bg-action-primary", style: { width: `${a}%` } })
      }
    ),
    /* @__PURE__ */ d("span", { className: "text-caption text-text-muted", children: [
      t,
      "/",
      r
    ] })
  ] });
}
const H = {
  elevated: "bg-bg-default shadow-card",
  outlined: "border border-border-default bg-bg-default",
  filled: "bg-bg-info"
};
function ie({ variant: t = "elevated", children: r }) {
  const e = ["rounded-md p-4", H[t]].join(" ");
  return /* @__PURE__ */ n("div", { className: e, children: r });
}
const M = "a, button, input, select, textarea, label, [role='button']";
function se({ columns: t, rows: r, onRowClick: e }) {
  const o = (a, i) => {
    var l;
    e && (a.target instanceof Element && a.target.closest(M) || (l = window.getSelection()) != null && l.toString() || e(i));
  };
  return /* @__PURE__ */ d("table", { className: "w-full text-left", children: [
    /* @__PURE__ */ n("thead", { className: "bg-track text-caption text-text-muted", children: /* @__PURE__ */ n("tr", { children: t.map((a) => /* @__PURE__ */ n("th", { scope: "col", className: "p-2 font-bold", children: a.header }, a.key)) }) }),
    /* @__PURE__ */ n("tbody", { children: r.map((a, i) => /* @__PURE__ */ n(
      "tr",
      {
        className: `border-b border-border-default${e ? " cursor-pointer hover:bg-bg-muted" : ""}`,
        onClick: e ? (l) => o(l, i) : void 0,
        children: t.map((l) => /* @__PURE__ */ n("td", { className: "p-2", children: l.key in a ? a[l.key] : null }, l.key))
      },
      i
    )) })
  ] });
}
function ce({ items: t }) {
  return /* @__PURE__ */ n("dl", { className: "divide-y divide-border-default", children: t.map((r) => /* @__PURE__ */ d("div", { className: "flex items-baseline justify-between gap-4 py-2", children: [
    /* @__PURE__ */ n("dt", { className: "font-bold text-text-muted", children: r.key }),
    /* @__PURE__ */ n("dd", { className: "text-right", children: r.value })
  ] }, r.key)) });
}
function de({ title: t, children: r, sticky: e = !1 }) {
  const o = [
    "flex h-14 items-center gap-4 bg-bg-default px-4 shadow-bar",
    e ? "sticky top-0" : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ d("header", { className: o, children: [
    t ? /* @__PURE__ */ n(I, { level: 1, children: t }) : null,
    r
  ] });
}
const Z = {
  solid: "bg-bg-default",
  frosted: "bg-bg-default/90 backdrop-blur-frosted"
};
function ue({ variant: t = "solid", children: r }) {
  const e = ["fixed inset-x-0 bottom-0 px-4 pt-3 shadow-bar-up", Z[t]].join(" ");
  return /* @__PURE__ */ n("div", { className: e, style: { paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }, children: r });
}
export {
  re as Badge,
  ue as BottomBar,
  z as Button,
  ie as Card,
  V as Checkbox,
  X as CheckboxGroup,
  ae as Chip,
  Q as DateInput,
  te as FormField,
  de as Header,
  I as Heading,
  ce as KeyValueList,
  K as Link,
  le as Loader,
  ne as Notice,
  oe as ProgressBar,
  ee as RadioGroup,
  J as Select,
  se as Table,
  W as Text,
  Y as TextField,
  q as Textarea
};
